var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { matchPath, useLocation, useSearchParams } from 'react-router';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAnalyticsContext } from 'src/common/metrics';
import { getMarketplace } from 'src/utils/marketplace';
import { routes } from 'src/utils/routes';
const HSP_PARAM = 'hsp';
// Function to ensure consistency of query key accross the application
export const getAppInitQueryKey = (marketplaceId) => ['getAppInit', marketplaceId];
export const useAppInit = (options) => {
    var _a;
    const rumClient = useAnalyticsContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const marketplaceId = getMarketplace(searchParams);
    const hasHspParam = searchParams.has(HSP_PARAM);
    const enabled = (_a = options === null || options === void 0 ? void 0 : options.enabled) !== null && _a !== void 0 ? _a : true;
    // Add hsp (Handshake Program) param before useAppInit if not present
    useEffect(() => {
        const newParams = new URLSearchParams(searchParams);
        if (!hasHspParam) {
            let hsp = 'unknown';
            if (matchPath(routes.productDetailPage, location.pathname)) {
                hsp = 'product_ads';
            }
            else if (matchPath(routes.creatorStorefrontPage, location.pathname)) {
                hsp = 'creator_ads';
            }
            else if (matchPath(routes.linkCampaignPage, location.pathname)) {
                hsp = 'link_campaign';
            }
            newParams.set(HSP_PARAM, hsp);
        }
        // If the marketplaceId is not valid, update it
        if (marketplaceId !== searchParams.get('marketplaceId')) {
            rumClient.recordEvent('INVALID_OR_MISSING_MARKETPLACE_ID', {
                url: window.location.href,
                referrer: document.referrer,
                userAgent: navigator.userAgent,
            });
            newParams.set('marketplaceId', marketplaceId);
        }
        if (newParams.toString() !== searchParams.toString()) {
            setSearchParams(newParams, { replace: true, state: location.state });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Run only once on mount to set hsp before useAppInit
    }, []);
    return useQuery({
        queryKey: getAppInitQueryKey(marketplaceId),
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () { return yield HandshakePainterServiceApiV1.initApp({ marketplaceId }); }),
        staleTime: Infinity, // Data stays fresh for the entire session
        enabled: enabled && hasHspParam,
    });
};
